import Editor from './index.vue'

export const editor_mixin = {
  components: {
    Editor
  },
  data() {
    return {
      isEditFullScreen: false
    }
  },
  computed: {
    editorFormItenClass() {
      return [
        "editor-fullscreen-formItem",
        {
          "nofull": !this.isEditFullScreen
        }
      ]
    }
  },
  methods: {
    editorFullScreenChange(isFull) {
      this.isEditFullScreen = isFull
    }
  }
}
